import { SystemStyleObject } from '@chakra-ui/react'

import { AI_PANEL_SIZE_TRANSITION, AI_PANEL_SIZE_TRANSITION_CLASSNAME, PREFERS_REDUCED_MOTION_QUERY } from 'src/components/constants'
import { PLAYBACK_HIGHLIGHT, TRANSCRIPT_HIGHLIGHT } from 'src/components/TranscriptViewer/constants'

import { paletteDefault } from './themes/palette.default'
import { Theme } from './themes/types'

type GlobalStylesType = (props: { theme: Theme }) => SystemStyleObject
export const globalStyles: GlobalStylesType = ({ theme }) => ({
    'html, body': {
        background: `${theme.palette.transcript.appBackgroundColors[theme.appBackgroundColorIndex].colorValue} !important`,
    },
    _focusVisible: {
        boxShadow: `0 0 0 1px ${theme.palette.global.focusIndicatorColor}`,
        outline: '2px solid transparent',
        outlineOffset: '2px',
        borderRadius: '4px',
    },
    '.verbit-select': {
        '&__menu-list': {
            backgroundColor: `${theme.palette.verbitSelect.listBgColor} !important`,
            boxShadow: theme.palette.verbitSelect.listShadow,
        },
        '&__option': {
            color: `${theme.palette.verbitSelect.optionColor} !important`,
            backgroundColor: 'transparent !important',
            '& .check-icon-wrapper svg path': {
                stroke: `${theme.palette.verbitSelect.checkIconColor} !important`,
            },
            '&.is-focused, &:not(.is-disabled):hover': {
                backgroundColor: `${theme.palette.verbitSelect.optionFocusedBgColor} !important`,
            },
        },
    },
    '.chakra-popover__content': {
        '--popper-bg': `${theme.palette.search.outerBorderColor} !important`,
        '--popper-arrow-shadow-color': `${theme.palette.search.outerBorderColor} !important`,
    },
    // Chromakey leaves searchResultHighlight empty; fall back so the highlight is not invisible.
    [`::highlight(${TRANSCRIPT_HIGHLIGHT})`]: {
        backgroundColor: theme.palette.transcript.searchResultHighlight || paletteDefault.transcript.searchResultHighlight,
    },
    [`::highlight(${PLAYBACK_HIGHLIGHT})`]: {
        backgroundColor: theme.palette.editor.activeMediaTimingHighlight,
    },
    [`.${AI_PANEL_SIZE_TRANSITION_CLASSNAME}`]: {
        transition: AI_PANEL_SIZE_TRANSITION,
        [`@media ${PREFERS_REDUCED_MOTION_QUERY}`]: {
            transition: 'none',
        },
    },
})
